import axios from 'axios';

export interface UserLocation {
  countryCode: string;
  countryName: string;
  continentCode: string;
  currency: string;
  ip: string;
}

export const getLocation = async (): Promise<UserLocation> => {
  // Debug Override: Check localStorage for manual country setting
  const debugCountry = localStorage.getItem('debug_country_code');
  const debugName = localStorage.getItem('debug_country_name') || 'Debug Country';

  if (debugCountry) {
    console.log(`[DEBUG] Using country override: ${debugCountry}`);
    return {
      countryCode: debugCountry.toUpperCase(),
      countryName: debugName,
      continentCode: debugCountry.toUpperCase() === 'RW' ? 'AF' : 'INT', // Simple mapping for debug
      currency: debugCountry.toUpperCase() === 'RW' ? 'RWF' : 'USD',
      ip: '127.0.0.1'
    };
  }

  try {
    const response = await axios.get('https://ipapi.co/json/');
    const data = response.data;
    
    // Determine continent (ipapi.co doesn't provide continent code directly in free tier sometimes, 
    // but we can map common African countries if needed or use continent_code if available)
    
    return {
      countryCode: data.country_code || 'RW',
      countryName: data.country_name || 'Rwanda',
      continentCode: data.continent_code || 'AF',
      currency: data.currency || 'RWF',
      ip: data.ip
    };
  } catch (error) {
    console.error('Error fetching location:', error);
    // Fallback to Rwanda defaults
    return {
      countryCode: 'RW',
      countryName: 'Rwanda',
      continentCode: 'AF',
      currency: 'RWF',
      ip: ''
    };
  }
};
